var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgEventFill = function SvgEventFill(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M9 16.5c-.7 0-1.3-.2-1.8-.7s-.7-1.1-.7-1.8.2-1.3.7-1.8 1.1-.7 1.8-.7 1.3.2 1.8.7.7 1.1.7 1.8-.2 1.3-.7 1.8-1.1.7-1.8.7M5 22a2 2 0 0 1-1.4-.6A2 2 0 0 1 3 20V6c0-.5.2-1 .6-1.4A2 2 0 0 1 5 4h1V3c0-.3.1-.5.3-.7S6.7 2 7 2s.5.1.7.3.3.4.3.7v1h8V3c0-.3.1-.5.3-.7s.4-.3.7-.3.5.1.7.3.3.4.3.7v1h1c.6 0 1 .2 1.4.6s.6.9.6 1.4v14c0 .6-.2 1-.6 1.4a2 2 0 0 1-1.4.6zm0-2h14V10H5z"
  })));
};
export default SvgEventFill;